import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
    const items = document.querySelectorAll(".counter-item");

    gsap.set(items, { opacity: 0, y: 30 });

    ScrollTrigger.create({
        trigger: ".counters",
        start: "top 80%",
        once: true,
        onEnter: () => {
            items.forEach((item, index) => {
                const numberEl = item.querySelector(".number");
                const start = +numberEl.dataset.start;
                const end = +numberEl.dataset.end;
                const suffix = numberEl.dataset.suffix || "";

                // Slide in each item with staggered delay
                gsap.to(item, {
                    opacity: 1,
                    y: 0,
                    duration: 0.6,
                    delay: index * 0.4,
                    ease: "power2.out",
                    onComplete: () => {
                        gsap.fromTo(
                            numberEl,
                            { innerText: start },
                            {
                                innerText: end,
                                duration: 2,
                                ease: "power1.out",
                                snap: { innerText: 1 },
                                onUpdate: function () {
                                    numberEl.textContent = `${Math.floor(
                                        numberEl.innerText
                                    ).toLocaleString()}${suffix}`;
                                },
                            }
                        );
                    },
                });
            });
        },
    });
});
